import React, { useEffect } from "react";
import Header from "../layout/Header";
import Footer from "../layout/Footer";
import Meta from "../Meta/Meta";
// import { Helmet } from "react-helmet";

function CancellationAndRefund() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {" "}
      <Header />
      <div className="container mx-auto px-8  max-md:px-4">
        <Meta
          title="Cancellation & Refund Policy | MaxiPitch"
          description="Read MaxiPitch cancellation and refund policy to understand subscription rules, payment terms, and refund eligibility for our AI sales automation services."
          url="https://maxipitch.com/cancellation-and-refund"
        />
        {/* <Helmet>
          <title>Know the SelfSync's cancellation & refund Policy</title>
          <meta
            name="description"
            content="Explore the cancellation and refund policy of SelfSync. Learn how to request refunds, cancel services, and understand our terms for digital creative services."
          />
          <link
            rel="canonical"
            href="https://maxipitch.com /cancellation-refund"
          />
        </Helmet> */}
        <div className="">
          <div className="text-center mb-8 mt-5 leading-tight">
            <h1 className="">Cancellation and refund policy</h1>
          </div>
          <div>
            <p className=" text-gray-700 mb-8 text-base">
              At <span className="font-bold">Digikore Studios Limited.</span>,
              we strive to provide the best experience with our visual effects
              and digital creative services. We understand that situations may
              arise where you might need to cancel a service or request a
              refund. Below is our policy on cancellations and refunds:
            </p>
          </div>
          <div>
            <h6 className="">Refunds</h6>
            <p className=" text-gray-700 mb-8 text-base">
              <ol>
                <li>
                  <span className="font-bold">• How to Request a Refund:</span>{" "}
                  To request a refund, simply send us a written notice
                  explaining your reason for dissatisfaction.{" "}
                </li>
                <li>
                  <span className="font-bold">• Refund Processing</span>: We
                  will review your request, and if it meets our refund criteria,
                  we’ll process your refund within 7 working days.{" "}
                </li>
              </ol>
            </p>
          </div>
          <div>
            <h6 className="">Cancellation</h6>
            <p className=" text-gray-700 mb-8 text-base ">
              <span className="font-bold">• Cancelling a Service:</span> You can
              cancel your service at any time.
              <ol>
                <li>
                  <span className="font-bold">• Before Completion:</span> If you
                  cancel before we’ve completed the agreed work, you will be
                  charged for the work done up until that point.
                </li>
                <li>
                  <span className="font-bold">• After Completion:</span> If the
                  work is already completed, no additional charges will apply
                  upon cancellation.
                </li>
              </ol>
            </p>
          </div>
          <div>
            <h6 className="">Additional Notes</h6>
            <p className=" text-gray-700 mb-8 text-base">
              <ol>
                <li>
                  <span className="font-bold">• Third-Party Charges:</span>{" "}
                  Please note that any third-party fees or charges (e.g.,
                  payment processing fees) are{" "}
                  <span className="font-bold">non-refundable</span>.{" "}
                </li>
                <li>
                  If you have any questions or need further assistance, feel
                  free to reach out to us at{" "}
                  <a
                    className="text-blue-600"
                    href="mailto: support@maxipitch.com "
                  >
                    support@maxipitch.com
                  </a>{" "}
                </li>
              </ol>
            </p>
          </div>
          <div>
            <h6 className="">Data Privacy & GDPR Compliance</h6>
            <p className=" text-gray-700 mb-8 text-base">
              In accordance with the General Data Protection Regulation (GDPR),
              any personal data you provide when requesting a cancellation or
              refund will be processed lawfully, fairly, and transparently. We
              only collect data necessary to process your request and maintain
              service records.
              <br />
              <br />
              You have the right to request access, correction, deletion, or
              restriction of your personal data at any time. To exercise your
              data rights, please contact us at{" "}
              <a className="text-blue-600" href="mailto:support@maxipitch.com ">
                support@maxipitch.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default CancellationAndRefund;
